/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MenuBar',['pixi', 'absolute', 'absolute/stringmanager', 'lodash', 'MenuUI/SlideOutMenu', 'MenuUI/MsftIconButton', 'Solitaire/Solitaire',
        'Solitaire/SolitaireGameMode', 'util/SettingsManager', 'MenuUI/DealWarningModal', 'gameconfig',
        'MenuUI/NewsDialog', 'MenuUI/StarCountDisplay', 'Solitaire/MvvmStructure/Service/SolitaireStarClubService',
        'Solitaire/MvvmStructure/Service/ManifestService', 'MenuUI/CreditsDialog', 'MenuUI/WarningModal',
        'Managers/TelemetryManager', 'Managers/BrowserUtils', 'Managers/ScaleManager', 'util/ScaleParams',
        'MenuUI/GameOptionsPopup', 'MenuUI/DetailStatsItemModel'],

    function (PIXI, Absolute, _s, _, SlideOutMenu, MsftIconButton, SolitaireGame, SolitaireGameMode, SettingsManager,
              DealWarningModal, GameConfig, NewsDialog, StarCountDisplay, SolitaireStarClubService, ManifestService,
              CreditsDialog, WarningModal, TelemetryManager, BrowserUtils, ScaleManager, ScaleParams, GameOptionsPopup,
              DetailStatsItemModel) {

        var MenuBar = function (config, ui, game) {
            var defaultConfig = {
                tiles: [],
                label: '',
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 35 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                },
                tilePaddingX: Absolute.Coords.x(24),
                tilePaddingY: Absolute.Coords.x(50)
            };
            this.fullScreenEnabled = Absolute.GameConfig.defaults.config.UI.fullScreenEnabled;
            this.initMenuBar(_.extend(defaultConfig, config), ui, game);
        };

        MenuBar.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        MenuBar.prototype.initMenuBar = function (config, ui, game) {

            PIXI.DisplayObjectContainer.call(this);

            this.supportUrl = Absolute.UIBuilder.getConfigData('AboutSlideOut')
                .buttonSections[0].buttons
                .filter(function (b) {
                    return b.text === 'buttons.support'
                })[0].data;

            this.privacyUrl = Absolute.UIBuilder.getConfigData('AboutSlideOut')
                .buttonSections[0].buttons
                .filter(function (b) {
                    return b.text === 'buttons.privacy'
                })[0].data;

            this.config = config;
            this.ui = ui;
            this.game = game;
            this.settingsManager = SettingsManager;
            this.backHandler = this._defaultBackHandler.bind(this);
            this.menuHandler = this.toggleMainSlideOut.bind(this);
            this.subMenuOpen = false;
            this.menuBarHeight = Absolute.Coords.y(66);

            // top overlay rect
            this.topBar = new PIXI.Graphics();
            this.topBar.beginFill(0x162640, 1);
            this.topBar.drawRect(0, 0, this.ui.width, Absolute.Coords.y(this.menuBarHeight));
            this.topBar.endFill();
            this.addChild(this.topBar);

            this.inputInterceptOverlay = new PIXI.Graphics();
            this.inputInterceptOverlay.beginFill(0x000001, 0);
            this.inputInterceptOverlay.drawRect(0, 0, this.ui.width, this.ui.height);
            this.inputInterceptOverlay.endFill();
            this.inputInterceptOverlay.visible = false;
            this.inputInterceptOverlay.interactive = true;
            this.inputInterceptOverlay.hitArea = new PIXI.Rectangle(0, 0, this.ui.width, this.ui.height);
            this.bindInteraction(this.inputInterceptOverlay, function () {
                this.toggleMainSlideOut();
                return;
            }.bind(this));
            this.inputInterceptOverlay.mousedown = function () {
            };
            this.addChild(this.inputInterceptOverlay);

            this.buildSlideOutMenus();
            this.menuButton = new MsftIconButton({
                'text': Absolute.StringManager('buttons.menu'),
                'icon': 'Buttons/Menu/Menu.png',
                'iconDown': 'Buttons/Menu/Menu_inv.png',
                'buttonOptions': {
                    'isDownBkgColor': 0x507DAD,
                    'isUpBkgColor': 0x507DAD,
                    'isDownStrokeColor': 0x95b0cd,
                    'isUpStrokeColor': 0x707886,
                    'isOverStrokeFill': 0x507DAD,
                    'isUpStrokeFill': 0x162640,
                    'bkgOpacity': 1
                },
                'width': Absolute.Coords.x(ScaleParams.menuBar.menuButton.width),
                'height': Absolute.Coords.x(ScaleParams.menuBar.menuButton.height),
                'upStroke': false,
                'textY': Absolute.Coords.y(38),
                'action': function () {
                    this.parent.addChild(this);
                    this.menuHandler();

                }.bind(this)
            });

            this.backButton = new MsftIconButton({
                'text': Absolute.StringManager('buttons.back'),
                'icon': 'Buttons/Back/Back.png',
                'iconDown': 'Buttons/Back/Back_inv.png',
                'buttonOptions': {
                    'isDownBkgColor': 0x507DAD,
                    'isUpBkgColor': 0x507DAD,
                    'isDownStrokeColor': 0x95b0cd,
                    'isUpStrokeColor': 0x707886,
                    'isOverStrokeFill': 0x507DAD,
                    'isUpStrokeFill': 0x162640,
                    'bkgOpacity': 1
                },
                'width': Absolute.Coords.x(ScaleParams.menuBar.backButton.width),
                'height': Absolute.Coords.x(ScaleParams.menuBar.backButton.height),
                'upStroke': false,
                'textY': Absolute.Coords.y(38),
                'action': function () {
                    this.showExitWarning(this.backHandler.bind(this));
                }.bind(this)
            });

            this.fullScreenButton = new MsftIconButton({
                'text': '',
                'icon': 'icon_fullscreen.png',
                'buttonOptions': {
                    'isDownBkgColor': 0x507DAD,
                    'isUpBkgColor': 0x507DAD,
                    'isDownStrokeColor': 0x95b0cd,
                    'isUpStrokeColor': 0x707886,
                    'isOverStrokeFill': 0x507DAD,
                    'isUpStrokeFill': 0x162640,
                    'bkgOpacity': 1
                },
                'iconSize': {width: Absolute.Coords.x(45), height: Absolute.Coords.x(45)},
                'iconDown': 'icon_fullscreen.png',
                'width': Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.width),
                'height': Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.height),
                'upStroke': false,
                'textY': Absolute.Coords.y(35),
                'action': function () {
                    this.getButtonHandler().toggleFullscreen();
                }.bind(this)
            });

            this.fullScreenButton.visible = this.fullScreenEnabled;

            this.menuButton.x = Absolute.Coords.x(ScaleParams.menuBar.menuButton.x);
            this.backButton.x = Absolute.Coords.x(ScaleParams.menuBar.backButton.x);
            this.fullScreenButton.x =
                (this.ui.width - this.fullScreenButton.width
                    - Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.offsetX)) * ScaleManager.scaleFactorX;
            this.backButton.visible = false;
            this.addChild(this.menuButton);
            this.addChild(this.fullScreenButton);
            this.addChild(this.backButton);


            this.firstRun = true;
            this.newsDialog = new NewsDialog();

            this.newsButton = PIXI.Sprite.fromFrame('btn_news.png');
            this.newsButtonWidth = this.newsButton.width;
            this.newsButtonHeight = this.newsButton.height;
            this.newsButton.x = this.fullScreenButton.visible
                ? this.fullScreenButton.x - (this.newsButton.width + Absolute.Coords.x(10)) * ScaleManager.scaleFactorX
                : this.fullScreenButton.x;
            this.newsButton.y = Absolute.Coords.y(ScaleParams.menuBar.newsButton.y) * ScaleManager.scaleFactorY;

            this.bindInteraction(this.newsButton, function () {
                if (ManifestService.IsValid()) {
                    this.newsDialog.show();
                } else {
                    this.showManifestWarning();
                }
            }.bind(this));
            this.addChild(this.newsButton);

            this.starCountDisplay = new StarCountDisplay({}, this, this.game);
            this.starCountDisplay.x = this.fullScreenEnabled ? Absolute.Coords.x(1617) : Absolute.Coords.x(1710);
            this.starCountDisplay.y = Absolute.Coords.y(0);
            this.starCountDisplay.visible = false;
            this.starCountWidth = this.starCountDisplay.width;
            this.starCountHeight = this.starCountDisplay.height;
            this.addChild(this.starCountDisplay);

            this.pageLabel = new PIXI.Text('', this.config.letterStyle);
            this.addChild(this.pageLabel);
            this.domGameContainer = document.documentElement;
            this.controlGroup = [this.menuButton, this.backButton, this.starCountDisplay, this.fullScreenButton];
            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
        };

        MenuBar.prototype._defaultBackHandler = function () {
            if (this.activeMenu && this.activeMenu.isOpen) {
                this.toggleMainSlideOut(function () {
                    this.game.navBack();
                }.bind(this));
            } else {
                this.game.navBack();
            }
        };

        MenuBar.prototype.showExitWarning = function (callback) {
            if (this.game.solitaire && this.game.solitaire.CurrentChallenge && this.game.fsm.current === "playing") {                
                var warning = new DealWarningModal(this.ui.currentScreen, "dialogs.warningHeadline", 'dialogs.challengeExitWarning',
                    function () {
                        var challenge = this.game.solitaire.CurrentChallenge;
                        var mode = challenge.GetModeName();
                        var timeSpent = Math.floor(this.game.solitaire.Authority.CardSupply.PreciseTimePlayed);
                        var difficulty = challenge.config.Difficulty;

                        if (challenge.config.Date) {
                            var timestampStr = challenge.config.Date.substring(6, 19);
                            var date = new Date(parseInt(timestampStr));
                            var releaseDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
                            TelemetryManager.challengeComplete('Abandoned', mode, timeSpent, releaseDate, difficulty)
                        } else {
                            var collectionName = SolitaireStarClubService.currentCollection.Name,
                                packName = SolitaireStarClubService.currentPack.Name;
                            TelemetryManager.starClubComplete('Abandoned', timeSpent, mode, difficulty, collectionName, packName);
                        }
                        callback();
                        warning.close();
                    }.bind(this),
                    function () {
                        warning.close();
                    }.bind(this)
                );

                this.game.gameScreenUI.warning = warning;
            } else {
                callback();
            }

        };

        MenuBar.prototype.setBackHandler = function (backHandler) {
            this.backHandler = backHandler;
            this.menuHandler = backHandler;
        };

        MenuBar.prototype.removeBackHandler = function (backHandler) {
            this.backHandler = this._defaultBackHandler.bind(this);
            this.menuHandler = this.toggleMainSlideOut.bind(this);
        };

        MenuBar.prototype.toggleMainSlideOut = function (callback) {
            var wait = 0,
                handleToggle = function () {
                    this.activeMenu.toggle(callback);
                    this.inputInterceptOverlay.visible = this.activeMenu.isOpen;
                }.bind(this);

            this.addChild(this.activeMenu);

            if (this.subMenu && this.subMenu.isOpen) {
                this.toggleSubMenu();
                wait = 300;
            }

            handleToggle();

            if (this.fullScreenEnabled) {
                this.checkFullScreenStatus();
            }

        };

        MenuBar.prototype.checkFullScreenStatus = function () {

            // make sure the correct fullscreen button is visible (sometimes fullscreen fails, or user exist with esc key)
            var isFullScreen = this.ui.isFullScreen(),
                fullscreenButton = this.activeMenu.getButton('fullScreen'),
                exitFullscreenButton = this.activeMenu.getButton('exitFullScreen');

            if (fullscreenButton && exitFullscreenButton) {
                fullscreenButton.visible = !isFullScreen;
                exitFullscreenButton.visible = isFullScreen;
            }

        };

        MenuBar.prototype.toggleSubMenu = function (button, slideOutMenu) {
            if (button && slideOutMenu && !this.subMenuOpen) {
                this.subMenuButton = button;
                this.subMenuButton.oldUp = this.subMenuButton.upTexture;
                this.subMenuButton.upTexture = this.subMenuButton.downTexture;
                this.subMenuOpen = true;
                this.subMenu = slideOutMenu;
                this.subMenu.onShow(
                    false, ((this.game.solitaire && this.game.solitaire.Authority) ?
                        this.game.solitaire.Authority.CardSupply.GameName : null)
                );
            } else if (this.subMenuOpen && this.subMenuButton) {
                this.subMenuOpen = false;
                this.subMenuButton.upTexture = this.subMenuButton.oldUp;
                this.subMenuButton.setTexture(this.subMenuButton.upTexture);
            }
            this.removeChild(this.subMenu);
            this.addChild(this.subMenu);
            this.subMenu.toggle();
        };

        MenuBar.prototype.openGameOptions = function (isToggleMenu) {
            var gameOptionsPopup = null;
            if (!this.isGame) {
                gameOptionsPopup = new GameOptionsPopup({
                    'contentLayout': 'MainSlideOut',
                    'buttonHandler': this.getButtonHandler(),
                    optionsName: ''
                }, this.game);
            } else {
                var gameName = this.game.gameScreenUI.gameName;
                var isChallenge = this.game.gameScreenUI.isChallenge;
                gameName += isChallenge ? 'Challenge' : '';
                gameOptionsPopup = new GameOptionsPopup({
                    'contentLayout': 'MainSlideOut',
                    'buttonHandler': this.getButtonHandler(),
                    optionsName: gameName
                }, this.game);
            }
            this.addChild(gameOptionsPopup.overlay);
            this.addChild(gameOptionsPopup);
            this.gameOptionsPopup = gameOptionsPopup;
            gameOptionsPopup.onClose.add(function () {
                this.gameOptionsPopup = null;
            }.bind(this));

            if (isToggleMenu)
                this.toggleMainSlideOut();
        };

        MenuBar.prototype.bindInteraction = function (sprite, handler) {

            sprite.interactive = true;
            sprite.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                sprite.touchstart = handler.bind(this);
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    sprite.click = handler.bind(this);
                }
            } else {
                sprite.click = handler.bind(this);
            }

        };

        MenuBar.prototype.openDirectlyToOptions = function () {
            this.toggleMainSlideOut();
            window.setTimeout(function () {
                this.subMenu = this.gameOptionsSlideout;
                this.toggleSubMenu();
            }.bind(this), 500);
        };

        MenuBar.prototype.getButtonHandler = function () {

            return {
                hintAction: function (skipToggle) {
                    skipToggle = !!skipToggle;
                    this.game.solitaire.Hint();
                    if (!skipToggle) {
                        this.toggleMainSlideOut();
                    }
                }.bind(this),
                switchGame: function (mode) {
                    this.showExitWarning(function () {
                        this.toggleMainSlideOut(function () {
                            this.game.startGame(SolitaireGameMode[mode], null, false);
                        }.bind(this));
                    }.bind(this));
                    TelemetryManager.menuOptionSelected(mode + 'FlyoutItem');
                }.bind(this),
                navDaily: function () {
                    this.showExitWarning(function () {
                        this.toggleMainSlideOut(function () {
                            this.game.navDaily();
                        }.bind(this));
                    }.bind(this));
                    TelemetryManager.menuOptionSelected('DailyChallengeFlyoutItem');
                }.bind(this),
                navStarClub: function () {
                    this.showExitWarning(function () {
                        this.toggleMainSlideOut(function () {
                            this.game.navStarClub();
                        }.bind(this));
                    }.bind(this));
                    TelemetryManager.menuOptionSelected('StarClubFlyoutItem');
                }.bind(this),
                openOptions: function (data, button) {
                    TelemetryManager.menuOptionSelected('OptionsFlyoutItem');
                    this.openGameOptions(true);
                }.bind(this),
                changeSetting: function (settingPrefix, setting, state) {
                    TelemetryManager.gameSettingChanged(settingPrefix, setting, state);
                    this.backButton.interactive = false;
                    var triggerSettingsChange = function () {
                        this.settingsManager.setSetting(settingPrefix, setting, state);
                        if (this.game.solitaire) {
                            this.game.solitaire.updateSetting(setting, state);
                        } else {
                            this.game.updateSetting(setting, state);
                        }
                    }.bind(this);

                    var handleRedeal = function (showAd) {
                        this.game.gameScreenUI.onHide();
                        this.game.menuBar.onHide();
                        triggerSettingsChange();

                        var seedOverride;
                        if (setting === 'gameNumber') {
                            seedOverride = '$' + state;
                        }
                        if (seedOverride) {
                            // console.log('Seed Override');
                            var dealGame = function () {
                                state ? this.game.solitaire.DealNewGame(seedOverride, showAd)
                                    : this.game.solitaire.DealNewGame(null, showAd);
                                this.ui.hideLoadingScreen();
                            }.bind(this);
                            if (this.game.solitaire.SupplyView.CardSupply.CardAnimator.IsShuffleAnimationRunning()) {
                                // console.log('Waiting for Shuffling');
                                this.ui.showLoadingScreen();
                                this.game.solitaire.SupplyView.CardSupply.CardAnimator.OnShuffleFinished = function () {
                                    dealGame();
                                    this.game.menuBar.onShow();
                                }.bind(this);
                            } else {
                                // console.log('Deal Game');
                                dealGame();
                                this.game.menuBar.onShow(false, true, false);
                            }
                        } else {
                            var gameMode = this.game.solitaire.ActiveMode.Name;
                            this.game.solitaire.Template.SaveGameOptions(this.game.solitaire.Authority.CardSupply);
                            this.game.solitaire.Authority.CardSupply.IsCardDragging = false;
                            this.game.startGame(
                                gameMode, null, true, (gameMode !== SolitaireGameMode.Klondike),
                                this.game.solitaire.Authority.CardSupply.HasMovedCards, false
                            );
                        }
                        if(this.gameOptionsPopup){this.gameOptionsPopup.destroy();}
                    }.bind(this);

                    if (GameConfig.settingRequiresRedeal[setting]
                        && this.game.solitaire.Authority.CardSupply.HasMovedCards) {
                        var warning = new DealWarningModal(this.ui.currentScreen, 'dialogs.newDealHeadline', 'dialogs.newDealContent',
                            function () {
                                handleRedeal(false);
                                warning.close();
                                this.backButton.interactive = true;
                            }.bind(this),
                            function () {
                                warning.close();
                                this.backButton.interactive = true;
                            }.bind(this)
                        );
                    } else if (GameConfig.settingRequiresRedeal[setting]) {
                        handleRedeal(false);
                        this.backButton.interactive = true;

                    } else {
                        triggerSettingsChange();
                        this.backButton.interactive = true;
                    }
                }.bind(this),
                openHtpMenu: function (data, button) {
                    TelemetryManager.menuOptionSelected('HowToPlayFlyoutItem');
                    var openModeHtp = function () {
                        var mode = SolitaireGameMode.getModeById([this.game.mode]);
                        this.toggleMainSlideOut(function () {
                            this.game.navHtp(mode);
                        }.bind(this));
                    }.bind(this);

                    if (this.game.fsm.current === 'playing' || (this.game.config.singleGame.enabled)) {
                        this.showExitWarning(openModeHtp);
                    } else {
                        this.toggleSubMenu(button, this.htpSlideout);
                    }
                }.bind(this),
                openHtp: function (gameMode) {
                    this.toggleMainSlideOut(function () {
                        this.game.navHtp(gameMode);
                    }.bind(this));
                }.bind(this),
                openLink: function (url) {
                    if (url === this.supportUrl) {
                        TelemetryManager.menuOptionSelected('SupportFlyoutItem');
                    }

                    if (url == this.privacyUrl && Absolute.StringManager.getUserLanguage().toLowerCase() !== "en-us") {
                        url = url.replace("en-us", Absolute.StringManager.getUserLanguage());
                    }

                    var win = window.open(url, '_blank');
                    win.focus();
                }.bind(this),
                openStatistics: function () {
                    var statsDetailModel = new DetailStatsItemModel(SolitaireGameMode[this.game.config.singleGame.mode]);
                    this.toggleMainSlideOut(this.game.navStatsDetail.bind(this.game, statsDetailModel));
                }.bind(this),
                openThemes: function () {
                    this.toggleMainSlideOut(this.game.navThemes.bind(this.game))
                }.bind(this),
                openAbout: function (data, button) {
                    TelemetryManager.menuOptionSelected('AboutFlyoutItem');
                    this.toggleSubMenu(button, this.aboutSlideout);
                }.bind(this),
                openCredits: function () {
                    this.toggleMainSlideOut();
                    this.ui.showCreditsDialog();

                }.bind(this),
                toggleFullscreen: function (data, button) {
                    if (!Absolute.Platform.supportsFullscreenApi()) {
                        var warningModal = new WarningModal(this.ui.currentScreen, _s('dialogs.fullScreenTitle'),
                            _s('dialogs.fullScreenContent'), function () {
                                warningModal.close();
                            });
                    } else {
                        var isFullScreen = this.ui.isFullScreen();
                        if (button) {
                            var otherButton = this.activeMenu.getButton(!isFullScreen
                                ? 'exitFullScreen' : 'fullScreen');
                            button.visible = false;
                            otherButton.visible = true;
                            this.toggleMainSlideOut();
                        }
                        if (!isFullScreen) {
                            this.ui.requestFullscreen(this.domGameContainer);
                        } else {
                            this.ui.exitFullScreen(this.domGameContainer);
                        }
                    }
                    TelemetryManager.fullscreenButtonClick(this.ui.isFullScreen())
                }.bind(this),
                resetCumulativeScore: function () {
                    // reset score and redeal
                    var warning = new DealWarningModal(this.ui.currentScreen, 'dialogs.newDealHeadline', 'dialogs.newDealContent',
                        function () {
                            var gameMode = this.game.solitaire.ActiveMode.Name;
                            this.toggleMainSlideOut(function () {
                                this.game.startGame(gameMode, null, true, true);
                                warning.close();
                            }.bind(this));
                        }.bind(this),
                        function () {
                            warning.close();
                        }
                    );
                }.bind(this),
                updateResetCumulativeScoreState: function () {
                    var scoreType = this.settingsManager.getSetting('klondike', 'scoringType'),
                        resetScoreButton = this.subMenu.getButton('resetCumulativeScore');
                    resetScoreButton.visible = scoreType === 'LASVEGASCUMULATIVE';
                }.bind(this)
            }
        };

        MenuBar.prototype.buildSlideOutMenus = function () {
            var mainSlideOut = (this.game.config.singleGame.enabled) ? 'SingleGameSlideOut' : 'MainSlideOut';
            // TODO: move layout and hanlder binding to config?
            this.mainMenuSlideout = new SlideOutMenu({
                'contentLayout': mainSlideOut,
                'buttonHandler': this.getButtonHandler(),
                'isMainMenu': true,
                'fullScreenEnabled': this.fullScreenEnabled
            });

            this.gameSlideout = new SlideOutMenu({
                'contentLayout': mainSlideOut,
                'buttonHandler': this.getButtonHandler(),
                'isMainMenu': false
            });

            this.gameSlideout.visible = false;

            this.gameOptionsSlideouts = {};

            this.htpSlideout = new SlideOutMenu({
                'contentLayout': 'HowToPlaySlideOut',
                'buttonHandler': this.getButtonHandler(),
                'isMainMenu': false,
                'isSubMenu': true
            });

            this.aboutSlideout = new SlideOutMenu({
                'contentLayout': 'AboutSlideOut',
                'buttonHandler': this.getButtonHandler(),
                'isMainMenu': false,
                'isSubMenu': true
            });

            this.activeMenu = this.mainMenuSlideout;

            this.addChild(this.mainMenuSlideout);
            this.addChild(this.gameSlideout);
            this.addChild(this.htpSlideout);
            this.addChild(this.aboutSlideout);
        };

        MenuBar.prototype.onShow = function (isMainMenu, showBackButton, isStarClub, pageLabel) {
            this.visible = true;

            this.backButton.visible = showBackButton;
            this.gameSlideout.visible = !isMainMenu && (this.game.solitaire && !this.game.solitaire.CurrentChallenge);
            this.mainMenuSlideout.visible = isMainMenu || (this.game.solitaire && this.game.solitaire.CurrentChallenge);
            this.newsDialog.shouldShowLink(function (showLink) {
                this.newsButton.visible = !!(isMainMenu && showLink);
            }.bind(this));
            this.starCountDisplay.visible = !!isStarClub;

            if (isMainMenu || (this.game.solitaire && this.game.solitaire.CurrentChallenge)) {
                this.activeMenu = this.mainMenuSlideout;
                this.mainMenuSlideout.onShow(isMainMenu);
                BrowserUtils.detectPrivateMode(function (isPrivate) {
                    if (this.firstRun) {
                        if (isPrivate) {
                            var privateBrowsingWarning = new WarningModal(
                                this.ui.currentScreen, 'dialogs.privateBrowsingWarningHeadline',
                                'dialogs.privateBrowsingWarningContent',
                                function () {
                                    privateBrowsingWarning.close();
                                    this.ui.mainScreen.initTutorial();
                                }.bind(this)
                            );
                        } else {
                            this.ui.mainScreen.initTutorial();
                        }

                        // var browserWarning = new WarningModal(this.parent,
                        // 	'dialogs.browserWarningHeadline', 'dialogs.browserWarningContent',
                        // 	function () {
                        // 		browserWarning.close();
                        // 	}.bind(this),
                        // 	function () { }
                        // );

                    }

                    if (isStarClub) {
                        this.starCountDisplay.onShow(
                            SolitaireStarClubService.GetStarClubGlobalStats().totalStarsEarned, this.firstRun);
                    }

                    this.firstRun = false;
                }, this);

            } else {
                this.activeMenu = this.gameSlideout;
                this.gameSlideout.onShow(isMainMenu);
            }


            if (showBackButton) {
                this.pageLabel.x = this.backButton.x + this.backButton.width + Absolute.Coords.x(20);
            } else {
                this.pageLabel.x = this.backButton.x;
            }
            this.pageLabel.y = this.topBar.y + (this.topBar.height - this.pageLabel.height) / 2;

            this.pageLabel.setText(pageLabel || '');
            this.handleResize();
        };

        MenuBar.prototype.onHide = function (isStarClub) {
            this.visible = false;

            if (isStarClub) {
                this.starCountDisplay.onHide();
            }

        };

        MenuBar.prototype.showManifestWarning = function () {
            this.ui.showWarning(_s("dialogs.manifestWarningHeadline"), _s("dialogs.manifestWarningContent"),
                function () {
                    this.ui.hideLoadingScreen();
                    this.game.navBack();
                }.bind(this)
            );
        };

        MenuBar.prototype.handleCommand = function (command) {
            if (this.gameOptionsPopup) {
                this.gameOptionsPopup.handleCommand(command);
            } else if (this.activeMenu) {
                this.activeMenu.handleCommand(command);
            }
        };
        MenuBar.prototype.handleCommand = function (command) {
            if (command === 'Back') {
                if (this.subMenuOpen && this.subMenu) {
                    this.toggleSubMenu();
                } else if (this.activeMenu) {
                    this.toggleMainSlideOut();
                }
            } else {
                if (this.subMenuOpen && this.subMenu) {
                    this.subMenu.handleCommand(command);
                } else if (this.activeMenu) {
                    this.activeMenu.handleCommand(command);
                }
            }
        };

        Object.defineProperty(MenuBar.prototype, "menuOpen", {
            get: function () {
                return this.activeMenu && this.activeMenu.isOpen;
            }
        });

        MenuBar.prototype.handleResize = function (isGame) {
            this.isGame = !!this.game.solitaire && !!this.game.solitaire.Authority;
            if (this.subMenu) {
                var seedInput = this.subMenu.getButton('seedInput');
                if (typeof seedInput !== 'undefined') {
                    seedInput.updateTempInputField();
                }
            }
            this.yScale = Math.max(Math.min((ScaleManager.height / 1080) + 0.3, 1), 0.7);
            this.xScale = Math.max(Math.min((ScaleManager.width / 1920) + 0.3, 1), 0.7);
            this.resizeScale = Math.min(this.yScale, this.xScale);
            this.resizeTopBar();
            this.resizeMenuButton();
            this.resizeBackButton();
            this.resizePageLabel();
            this.resizeFullScreenButton();
            this.resizeNewsButton();
            this.resizeStarCountDisplay();
        };

        MenuBar.prototype.resizeStarCountDisplay = function () {
            this.starCountDisplay.width = this.starCountWidth / ScaleManager.scaleFactorX;
            this.starCountDisplay.height = this.starCountHeight / ScaleManager.scaleFactorY;
            this.starCountDisplay.x = this.fullScreenEnabled
                ? this.fullScreenButton.x - this.starCountDisplay.width - Absolute.Coords.x(10) * ScaleManager.scaleFactorX
                : this.ui.width - this.starCountDisplay.width - Absolute.Coords.x(10) * ScaleManager.scaleFactorX;

            if (Absolute.Platform.isMobile()) {
                this.starCountDisplay.width = this.starCountWidth / ScaleManager.scaleFactorX * 0.7;
                this.starCountDisplay.height = this.starCountHeight / ScaleManager.scaleFactorY * 0.7;
                this.starCountDisplay.x = this.ui.width - this.starCountDisplay.width;
            }
        };

        MenuBar.prototype.resizeBackButton = function () {
            var backButtonMeasures = ScaleParams.menuBar.backButton;
            this.backButton.x = this.menuButton.x + this.menuButton.width + Absolute.Coords.x(15);
            if (!this.isGame && !Absolute.Platform.isMobile()) {
                this.backButton.width = Absolute.Coords.x(backButtonMeasures.width) / ScaleManager.scaleFactorX;
                this.backButton.height = Absolute.Coords.x(backButtonMeasures.height) / ScaleManager.scaleFactorY;
            } else {
                var height = this.resizeScale *
                    (Absolute.Coords.x(backButtonMeasures.height) / ScaleManager.scaleFactorY);
                var width = this.resizeScale *
                    (Absolute.Coords.x(backButtonMeasures.width) / ScaleManager.scaleFactorX);
                this.backButton.height = height;
                this.backButton.width = width;
            }

            if (this.isGame && Absolute.Platform.isMobile()) {
                this.menuButton.visible = false;
                this.backButton.x = this.menuButton.x;
            }
            else {
                this.menuButton.visible = true;
                this.backButton.x = this.menuButton.x + this.menuButton.width + Absolute.Coords.x(15);
            }
        };

        MenuBar.prototype.resizeFullScreenButton = function () {
            if (!this.isGame && !Absolute.Platform.isMobile()) {
                this.fullScreenButton.width =
                    Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.width) / ScaleManager.scaleFactorX;
                this.fullScreenButton.height =
                    Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.height) / ScaleManager.scaleFactorY;
            } else {
                var height = this.resizeScale *
                    (Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.height) / ScaleManager.scaleFactorY);
                var width = this.resizeScale *
                    (Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.width) / ScaleManager.scaleFactorX);
                this.fullScreenButton.height = height;
                this.fullScreenButton.width = width;
            }
            this.fullScreenButton.x =
                (this.ui.width - this.fullScreenButton.width - ScaleParams.menuBar.fullScreenButton.offsetX);
        };

        MenuBar.prototype.resizeNewsButton = function () {
            if (!this.isGame && !Absolute.Platform.isMobile()) {
                this.newsButton.width = Absolute.Coords.x(this.newsButtonWidth) / ScaleManager.scaleFactorX;
                this.newsButton.height = Absolute.Coords.x(this.newsButtonHeight) / ScaleManager.scaleFactorY;
            } else {
                var height = this.resizeScale * (Absolute.Coords.x(this.newsButtonHeight) / ScaleManager.scaleFactorY);
                var width = this.resizeScale * (Absolute.Coords.x(this.newsButtonWidth) / ScaleManager.scaleFactorX);
                this.newsButton.height = height;
                this.newsButton.width = width;
            }
            this.newsButton.x = this.fullScreenButton.visible
                ? this.fullScreenButton.x - (this.newsButton.width + 10)
                : this.fullScreenButton.x;
            this.newsButton.y = Absolute.Coords.y(ScaleParams.menuBar.newsButton.y) * ScaleManager.scaleFactorY;
        };

        MenuBar.prototype.resizeMenuButton = function () {
            var menuButtonMeasures = ScaleParams.menuBar.menuButton;
            if (!this.isGame && !Absolute.Platform.isMobile()) {
                this.menuButton.x = Absolute.Coords.x(menuButtonMeasures.x) / ScaleManager.scaleFactorX;
                this.menuButton.width = Absolute.Coords.x(menuButtonMeasures.width) / ScaleManager.scaleFactorX;
                this.menuButton.height = Absolute.Coords.x(menuButtonMeasures.height) / ScaleManager.scaleFactorY;
            } else {
                var height = this.resizeScale * (Absolute.Coords.x(menuButtonMeasures.height) / ScaleManager.scaleFactorY);
                var width = this.resizeScale * (Absolute.Coords.x(menuButtonMeasures.width) / ScaleManager.scaleFactorX);
                this.menuButton.x = Absolute.Coords.x(menuButtonMeasures.x) * this.resizeScale;
                this.menuButton.height = height;
                this.menuButton.width = width;
            }
        };

        MenuBar.prototype.resizePageLabel = function () {
            this.removeChild(this.pageLabel);
            this.pageLabel = new PIXI.Text(this.pageLabel.text, this.config.letterStyle);
            this.pageLabel.scale.set(1 / ScaleManager.scaleFactorX, 1 / ScaleManager.scaleFactorY);

            if (Absolute.Platform.isMobile()) {
                this.pageLabel.scale.set(1 / (ScaleManager.scaleFactorX * 2), 1 / (ScaleManager.scaleFactorY * 2));
                this.pageLabel.visible = true;

                if (this.backButton.visible) {
                    this.pageLabel.x = this.backButton.x + this.backButton.width + Absolute.Coords.x(50);
                } else {
                    this.pageLabel.x = this.menuButton.x + this.menuButton.width + Absolute.Coords.x(50);
                }
                this.pageLabel.y = Absolute.Coords.y(5) + this.topBar.y + (this.topBar.height - this.pageLabel.height) / 2;
            }
            else {
                if (this.backButton.visible) {
                    this.pageLabel.x = this.backButton.x + this.backButton.width + Absolute.Coords.x(20);
                } else {
                    this.pageLabel.x = Absolute.Coords.x(ScaleParams.menuBar.backButton.x) / ScaleManager.scaleFactorX;
                }
                this.pageLabel.y = Absolute.Coords.y(5) + this.topBar.y + (this.topBar.height - this.pageLabel.height) / 2;
                if (this.newsButton.visible && this.newsButton.x <= this.pageLabel.x + this.pageLabel.width) {
                    this.pageLabel.visible = false;
                } else if (this.fullScreenButton.visible
                    && this.fullScreenButton.x <= this.pageLabel.x + this.pageLabel.width) {
                    this.pageLabel.visible = false;
                } else if (this.fullScreenButton.visible && this.backButton.visible && (ScaleManager.width <=
                    (ScaleParams.menuBar.pageLabelHidePoint - Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.width)
                        - Absolute.Coords.x(ScaleParams.menuBar.backButton.width)))) {
                    this.pageLabel.visible = false;
                } else if (this.fullScreenButton.visible && (ScaleManager.width <= (ScaleParams.menuBar.pageLabelHidePoint
                    - Absolute.Coords.x(ScaleParams.menuBar.fullScreenButton.width)))) {
                    this.pageLabel.visible = false;
                } else if (this.backButton.visible && (ScaleManager.width <= ScaleParams.menuBar.pageLabelHidePoint
                    - Absolute.Coords.x(ScaleParams.menuBar.backButton.width))) {
                    this.pageLabel.visible = false;
                } else if (ScaleManager.width <= ScaleParams.menuBar.pageLabelHidePoint) {
                    this.pageLabel.visible = false;
                } else {
                    this.pageLabel.visible = true;
                }
            }
            this.addChild(this.pageLabel);
            if (this.gameOptionsPopup) {
                this.setChildIndex(this.pageLabel, this.children.length - 4);
            }
        };

        MenuBar.prototype.resizeTopBar = function () {
            this.removeChild(this.topBar);
            this.topBar = new PIXI.Graphics();
            if (!this.isGame && !Absolute.Platform.isMobile()) {
                this.topBar.beginFill(0x162640, 1);
                this.topBar.drawRect(
                    0, 0, this.ui.width, this.menuBarHeight / (ScaleManager.scaleFactorY));
            } else {
                var height = this.resizeScale * (this.menuBarHeight / ScaleManager.scaleFactorY);
                this.topBar.beginFill(0x00001, 0.5);
                this.topBar.drawRect(0, 0, this.ui.width, height);
            }
            this.topBar.endFill();
            this.addChild(this.topBar);
            this.setChildIndex(this.topBar, 0)
        };

        MenuBar.prototype.resetTopBar = function (isGame) {
            this.removeChild(this.topBar);
            this.topBar = new PIXI.Graphics();
            this.topBar.beginFill(isGame ? 0x00001 : 0x162640, isGame ? 0.5 : 1);
            this.topBar.drawRect(
                0, 0, this.ui.width / (ScaleManager.scaleFactorX),
                this.menuBarHeight / (ScaleManager.scaleFactorY));
            this.topBar.endFill();
            this.addChild(this.topBar);
            this.setChildIndex(this.topBar, 0);

            this.menuButton.updateTexture(isGame);
            this.backButton.updateTexture(isGame);

            this.addChild(this.menuButton);
            this.addChild(this.backButton);
            this.setChildIndex(this.menuButton, 1);
            this.setChildIndex(this.backButton, 2);
            this.handleResize();
        };


        return MenuBar;

    });

